import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ModalController, Platform, ToastController } from '@ionic/angular';
import { Country } from 'src/data/mygolf.data';
import { MessageDisplayUtil } from 'src/message-display-utils';
import { PlayerService } from 'src/providers/player-service/player-service';


export interface PlayerModel {
  _playerName?: string | null;
  _gender?: string | null; 
}

@Component({
  selector: 'app-add-player',
  templateUrl: './add-player.page.html',
  styleUrls: ['./add-player.page.scss'],
})
export class AddPlayerPage implements OnInit {
  @Input () option:string;
  playerForm: UntypedFormGroup;
  registerThisPlayer: boolean = true;
  _playerName: string;
  _email: string;
  _gender: string = 'M';
  _phone: string;
  _nationalityId: string;
  _nric: string;
  _passport: string;
  playerModel: PlayerModel[] = [];
  constructor(  private modalCtl: ModalController,  
    private platform: Platform,
     private toastCtl: ToastController,
     private playerService: PlayerService) {

    if(this.option!="register"){
      const obj: PlayerModel = {
        _playerName: null,
        _gender: 'M'       
      };
      this.playerModel.push(obj);
    }
   }

  ngOnInit() {
    this.getCountry();
  }

  backRouting(){
    this.modalCtl.dismiss();
  }


  getHeaderName(){
    if(this.option==="register") return "Register Player";
    else return "New Player(s)";
  }

  getButtonName(){
    if(this.option==="register") return "Register and Add";
    else return "Include Names";
  }

  AddPlayer(){
    var count=0;
    for (let x = 0; x < this.playerModel.length; x++) {
        const element = this.playerModel[x];
        if(!!element._playerName) count++;
    }

    if(count != this.playerModel.length){
      MessageDisplayUtil.showMessageToast(
        "Please Enter Player Name!",
        this.platform,
        this.toastCtl,
        3000,
        'bottom',
      );
    }
    else{
      const obj: PlayerModel = {
        _playerName: null,
        _gender: 'M'       
      };
      this.playerModel.push(obj);
    }
  }

  definePlayerForm(){
    this.playerForm = new UntypedFormGroup({
      playerName: new UntypedFormControl(
        "",
        Validators.required,
      ),
      email: new UntypedFormControl(
        "",
        Validators.required,
      ),
      phone: new UntypedFormControl(
        "",
        Validators.required,
      ),
      gender: new UntypedFormControl(
        "M",
        Validators.required,
      ),
      registerThisPlayer:new UntypedFormControl(true, Validators.required)
    });
  }

  addPlayer(){
    if(this.option==="register"){
      
      if (!this._email || !this._playerName || this._email.length === 0 || this._playerName.length === 0) {
        MessageDisplayUtil.showErrorToast('Please fill-in Player Name and Email Address', this.platform, this.toastCtl, 5000, "bottom");
        return false;
      }
      // console.debug("register this player : ", this._email, this.emailIsValid(this._email))
      if (!this.emailIsValid(this._email)) {
          MessageDisplayUtil.showErrorToast('Please use valid Email Address', this.platform, this.toastCtl, 5000, "bottom");
          return false;
      }
      if (!this._nationalityId || this._nationalityId === '') {
        MessageDisplayUtil.showErrorToast('Please select Nationality', this.platform, this.toastCtl, 5000, "bottom");
        return false;
    }
      this.modalCtl.dismiss({
        option: this.option,       
        email: this._email,
        playerName: this._playerName,
        gender: this._gender,
        phone: this._phone,  
        nationality: this._nationalityId,
        nric: this._nric,
        passport: this._passport,
    });
    }
    else{
      var list =   this.playerModel
      .filter(player => player._playerName !== null && player._playerName !== undefined && player._playerName.trim() !== "")
      .map(player => ({ playerName: player._playerName!, gender: player._gender }));

      if(list.length>0){
        this.modalCtl.dismiss({
          option: this.option,
          playerDetails: list,
          email: this._email,
          playerName: this._playerName,
          gender: this._gender,
          phone: this._phone,
      });
      }
      else{
        this.modalCtl.dismiss();
      }     
    } 
  }

  
  countryList: Array<Country>;
  getCountry() {
      this.playerService.getCountryList()
              .subscribe((data: Array<Country>) => {
                          this.countryList = data;
      });
  }
  
  emailIsValid(email) {
    //console.log("email is : ", email);
    //console.log("email is valid : ", /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))
    return (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) //latest Aug 2022
    //   return /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|
    //     \\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|
    //     \[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:
    //     (?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test
    // return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}
}
